// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"732":"bddb8548d40452b4","888":"0fef3f6ea2cc34fa"}[chunkId] + ".css";
};